<template>
  <div class="pick">
    <van-button
      :plain="plain1"
      size="mini"
      type="info"
      @click="changebtn('date')"
      >日</van-button
    >
    <van-button
      :plain="plain2"
      size="mini"
      type="info"
      @click="changebtn('month')"
      >月</van-button
    >
    <van-button
      :plain="plain3"
      size="mini"
      type="info"
      @click="changebtn('year')"
      >年</van-button
    >
    <div class="datebox" v-show="!plain1">
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="value1"
        label="选择日期"
        placeholder="点击选择"
        @click="show1 = true"
      />
    </div>
    <div class="datebox" v-show="!plain2">
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="value2"
        label="选择日期"
        placeholder="点击选择"
        @click="show2 = true"
      />
    </div>
    <div class="datebox" v-show="!plain3">
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="value3"
        label="选择日期"
        placeholder="点击选择"
        @click="show3 = true"
      />
    </div>
    <van-popup v-model="show1" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onConfirm"
        @cancel="show1 = false"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <van-popup v-model="show2" position="bottom">
      <van-datetime-picker
        type="year-month"
        @confirm="onConfirm"
        @cancel="show2 = false"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <van-popup v-model="show3" position="bottom">
      <van-picker
        show-toolbar
        v-model="value3"
        type="year-month"
        @confirm="onConfirm"
        :columns="columns"
        @cancel="show3 = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { formatTime } from "../util/index";
export default {
  data() {
    return {
      minDate: new Date(2022, 0, 1),
      maxDate: new Date(2032, 10, 1),
      currentDate: new Date(),
      // 确认切换类型
      typetrue: "date",
      plain1: false,
      plain2: true,
      plain3: true,
      // 显示
      show1: false,
      show2: false,
      show3: false,
      value1: null,
      value2: null,
      value3: null,
      columns: [
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032"
      ],
      // 传给父
      date: ""
    };
  },
  mounted() {
    this.value1 = formatTime(new Date(), "yyyy/MM/dd");
    this.value2 = formatTime(new Date(), "yyyy/MM");
    this.value3 = formatTime(new Date(), "yyyy");
    this.date = formatTime(new Date(), "yyyyMMdd");
    this.infodate();
  },
  methods: {
    // 点击按钮
    changebtn(type) {
      this.typetrue = type;
      if (type === "date") {
        this.plain1 = false;
        this.plain2 = true;
        this.plain3 = true;
        this.show1 = false;
        this.date = formatTime(this.value1, "yyyyMMdd");
        console.log(this.data);
        console.log(this.value1);
      } else if (type === "month") {
        this.plain1 = true;
        this.plain2 = false;
        this.plain3 = true;
        this.show2 = false;
        console.log(this.value2);
        let arr = this.value2.split("/");

        if (Number(arr[1]) < 10) {
          arr[1] = "0" + Number(arr[1]);
        }
        console.log(arr[1]);
        this.date = arr[0] + arr[1];
      } else if (type === "year") {
        this.plain1 = true;
        this.plain2 = true;
        this.plain3 = false;
        this.show3 = false;
        this.date = formatTime(this.value3, "yyyy");
      }
      this.infodate();
    },
    // 子传父数据
    infodate() {
      this.$emit("updateList", { dateType: this.typetrue, date: this.date });
    },
    // 修改数据格式
    formatDate(date) {
      if (this.typetrue === "date") {
        this.date = formatTime(date, "yyyyMMdd");
        return `${date.getFullYear()}/${
          Number(date.getMonth() + 1) < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1
        }/${date.getDate()}`;
      }
      if (this.typetrue === "month") {
        this.date = formatTime(date, "yyyyMM");

        return `${date.getFullYear()}/${date.getMonth() + 1}`;
      }
      if (this.typetrue === "year") {
        this.date = formatTime(date, "yyyy");
        return `${formatTime(date, "yyyy")}`;
      }
    },
    // 确认
    onConfirm(value) {
      console.log(value);
      if (this.typetrue === "date") {
        this.show1 = false;
        this.value1 = this.formatDate(value);
      }
      if (this.typetrue === "month") {
        this.show2 = false;
        console.log(this.value2);
        this.value2 = this.formatDate(value);
      }
      if (this.typetrue === "year") {
        this.show3 = false;
        this.value3 = this.formatDate(value);
      }
      this.infodate();
    }
  }
};
</script>

<style scoped lang="less">
.pick {
  background-color: #fff;
  // margin-bottom: 10px;
  box-shadow: 1px 1px 1px #ececec;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  .van-button {
    width: 50px;
  }
  // .datebox {
  //   // flex: 1;
  // }
}
</style>
